import React from "react";

/** Wireframe stroke icons (24x24 path data lifted from the HTML wireframes). */
export const PATHS = {
  building: "M3 22V3h9v19 M12 8h8v14 M6 7h3 M6 12h3 M6 17h3 M15 12h2 M15 17h2",
  shield: "m12 3 9 3v6c0 5-9 10-9 10S3 17 3 12V6z M7 12l3 3 7-7",
  shieldPlain: "m12 3 9 3v7c0 6-9 10-9 10S3 16 3 10V6z",
  route: "M6 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6 M18 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6 M6 7v8h12V9 M14 12l4-4 4 4",
  globe: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M3 12h18 M12 3c-5 5-5 13 0 18 M12 3c5 5 5 13 0 18 M5 7h14 M5 17h14",
  truck: "M2 5h12v13H2z M14 10h4l4 5v3h-8 M5 18a2 2 0 1 0 .01 0 M17 18a2 2 0 1 0 .01 0",
  star: "m12 2 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z",
  search: "M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M15 15l6 6",
  chevron: "m7 10 5 5 5-5",
  chat: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7l-5 3V7a3 3 0 0 1 3-3 M8 9h7 M8 13h3",
  users: "M15 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 21v-3a7 7 0 0 1 14 0v3 M18 4a3 3 0 0 1 0 6 M21 20v-5",
  box: "m12 3 9 5-9 5-9-5z M3 8v10l9 5 9-5V8 M12 13v10 M8 5l9 5",
  gear: "m9 3 6 0 1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  clock: "M21 13a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M12 7v6l4 3 M10 1h4",
  card: "M3 5h18v15H3z M3 10h18 M6 15h4",
  check: "m5 12 4 4L19 6",
  trash: "M4 6h16 M9 3h6 M7 6l1 15h8l1-15 M10 10v7 M14 10v7",
  clipboard: "M5 5h14v17H5z M5 10h14 M9 5V3h6v7 M12 10v4",
  pin: "M19 9c0 6-7 12-7 12S5 15 5 9a7 7 0 1 1 14 0 M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
  bell: "M5 17h14l-2-4V9a5 5 0 0 0-10 0v4z M10 21h4",
  link: "m10 8 3-3a4 4 0 0 1 6 6l-3 3 M14 16l-3 3a4 4 0 0 1-6-6l3-3 M8 16l8-8",
  palette: "M12 3a9 9 0 1 0 0 18c3 0-1-5 3-5h3c5-2 2-13-6-13 M7 8h.1 M12 6h.1 M17 9h.1 M6 13h.1",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  calendar: "M4 5h16v16H4z M4 10h16 M8 2v6 M16 2v6",
  phone: "M5 3 2 6c0 8 8 16 16 16l3-3-5-5-3 3c-3-1-5-3-6-6l3-3z",
  mail: "M3 5h18v14H3z M3 6l9 7 9-7",
  arrow: "M4 12h16 M14 6l6 6-6 6",
  upload: "M12 16V3 M7 8l5-5 5 5 M4 15v6h16v-6",
  doc: "M5 3h9l5 5v14H5z M14 3v6h5 M8 13h7 M8 17h5",
  close: "m7 7 10 10 M7 17 17 7",
};

export function Icon({ name, d, className = "icon", ...rest }) {
  return (
    <svg aria-hidden="true" className={className} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" viewBox="0 0 24 24" {...rest}>
      <path d={d || PATHS[name]} />
    </svg>
  );
}

export default Icon;
